var map = {
	"./fortuneIcon.svg": 689,
	"./fortuneIconL.svg": 690,
	"./helpdeskIcon.svg": 691,
	"./helpdeskIconL.svg": 692,
	"./homeIcon.svg": 693,
	"./homeIconLarge.svg": 694,
	"./jackpotIcon.svg": 695,
	"./logo.svg": 696,
	"./logoSmall.svg": 697,
	"./loyaltyIcon.svg": 698,
	"./mobileAppIcon.svg": 699,
	"./profileIcon.svg": 700,
	"./questIcon.svg": 701,
	"./questsIcon.svg": 702,
	"./rewardLineupIcon.svg": 703,
	"./searchIcon.svg": 704,
	"./searchIconLarge.svg": 705,
	"./signOutIcon.svg": 706,
	"./star.svg": 707,
	"./tournamentIcon.svg": 708,
	"./tournamentLargeIcon.svg": 709,
	"./vipIcon.svg": 710,
	"./wheelIcon.svg": 711,
	"./wheelIconL.svg": 712,
	"./wheelIconMobile.svg": 713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 688;